import { render, staticRenderFns } from "./ratemanage.vue?vue&type=template&id=30366342"
import script from "./ratemanage.vue?vue&type=script&lang=ts"
export * from "./ratemanage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports